<template>
  <div class="instance-purchase-new-select-plan">
    <nuttrema-loader v-if="InstancePlanPurchaseSubscriptionOptions.fetching"></nuttrema-loader>

    <nuttrema-empty-result
      v-else-if="_get(InstancePlanPurchaseSubscriptionOptions, 'error.statusCode') === 403"
      class="with-logo"
      icon="far fa-eye-slash">
      <template slot="text">
        <h1 v-html="_get(InstancePlanPurchaseSubscriptionOptions, 'error.error') || $t('label.error_403_title')"></h1>
        <h4 v-html="_get(InstancePlanPurchaseSubscriptionOptions, 'error.message') || $t('label.error_403_text')"></h4>
      </template>
      <el-button v-if="_get(meta, 'navigation.cancel')" slot="button" type="text" @click="gotoPage(_get(meta, 'navigation.cancel'))">{{ $t('label.cancel') }}</el-button>
    </nuttrema-empty-result>

    <nuttrema-empty-result
      v-else-if="_get(InstancePlanPurchaseSubscriptionOptions, 'meta.preconditions.code') === INST_PLAN_PURCHASE_CODE.PLAN_PURCHASE_ENQUEUED_EXISTS"
      class="with-logo"
      icon="far fa-info">
      <template slot="text">
        <h1>{{ $t('label.info') }}</h1>
        <h4 v-html="_markdown.render($t('message.plan_purchase_enqueued_exists'))"></h4>
      </template>
      <el-button v-if="_get(meta, 'navigation.cancel')" slot="button" type="text" @click="gotoPage(_get(meta, 'navigation.cancel'))">{{ $t('label.close') }}</el-button>
    </nuttrema-empty-result>

    <instance-purchase-new-select-plan
       v-else
       theme="gray"
      :disabled="!edit"
      :InstanceSubscriptionOptions="InstancePlanPurchaseSubscriptionOptions"
      @cancel="onCancelEvent"
      @saveSelection="handleSelectPlan">
    </instance-purchase-new-select-plan>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { INST_PLAN_PURCHASE_CODE } from 'constants/values';

import PageProps from 'components/mixins/page-props';
import InstancePurchaseNewSelectPlan from 'components/ui/subscription/cmpt-instance-purchase-new-select-plan';

export default {
  name: 'page-instance-purchase-new-select-plan',
  mixins: [PageProps],
  components: {
    InstancePurchaseNewSelectPlan,
  },
  data() {
    return {
      edit: true,
      INST_PLAN_PURCHASE_CODE,
    };
  },
  methods: {
    ...mapActions([
      'SaveInstancePlanPurchaseSubscriptionSelection',
    ]),
    handleSelectPlan(payload) {
      this.SaveInstancePlanPurchaseSubscriptionSelection({ payload }).then(() => {
        this.onSuccessEvent();
      }).catch(() => {
        this.errorNotification();
      });
    },
  },
  computed: {
    InstanceDetails() {
      return this.$store.getters.InstanceDetails;
    },
    InstancePlanPurchaseSubscriptionOptions() {
      return this.$store.getters.InstancePlanPurchaseSubscriptionOptions;
    },
  },
  created() {
    this.$store.dispatch('GetInstancePlanPurchaseSubscriptionOptions');
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInstancePlanPurchaseSubscriptionOptions');
  },
};
</script>

<style lang="scss" scoped>
  .instance-purchase-new-select-plan {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    align-self: stretch;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscriptions/purchase-new/step-1/page-instance-purchase-new-select-plan.vue